export default "__VITE_ASSET__4d9ff15a__"